import { render, staticRenderFns } from "./RuleCard.vue?vue&type=template&id=4cd4fa9f&scoped=true&"
import script from "./RuleCard.vue?vue&type=script&lang=js&"
export * from "./RuleCard.vue?vue&type=script&lang=js&"
import style0 from "./RuleCard.vue?vue&type=style&index=0&id=4cd4fa9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4fa9f",
  null
  
)

export default component.exports